import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileUploadModule } from '@common/file-uploading-status-box/file-upload.module';
import { LibraryHelper } from '@services/helpers/library-helper';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { LibraryPrimeNgModule } from '../../library-primeNg.module';
import { LibraryImageEditorModule } from '../lib-image-editor/library-image-editor.module';
import { LibraryMenuModule } from '../library-menu/library-menu.module';
import { LibraryViewModeComponent } from './library-view-mode.component';

@NgModule({
  declarations: [LibraryViewModeComponent],
  imports: [
    CommonModule,
    LibraryPrimeNgModule,
    CommonSharedModule,
    PipeDirectiveModule,
    FileUploadModule,
    LibraryImageEditorModule,
    LibraryMenuModule,
  ],
  exports: [LibraryViewModeComponent],
  providers: [LibraryHelper],
})
export class LibraryViewModeModule {}
